// extracted by mini-css-extract-plugin
module.exports = {"conRequisitesWrapper":"styles_conRequisitesWrapper__2PyrG","requisites":"styles_requisites__2JFaA","map":"styles_map__1bZyR","iframe":"styles_iframe__3eyyE"};